module.exports = __webpack_public_path__ + "static/media/rich-text-notes.9d4736e1.png";